import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ConversionCTA = () => (
  <section className="section" style={{ background: "var(--lrg-bg)" }} data-testid="conversion-cta-section">
    <div className="container-custom">
      <div className="max-w-xl mx-auto text-center">
        <p className="font-editorial text-3xl sm:text-4xl font-medium text-[#F2EDE4] leading-[1.2] mb-5">
          Choose your location.<br />Find your program.<br />Get on court.
        </p>
        <p className="text-[11px] text-[#3A3D40] mb-12 tracking-wider">
          Your next step is one click away.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/contact" className="btn-lime" data-testid="final-cta-start">
            Start Your Journey <ArrowRight className="w-3.5 h-3.5" />
          </Link>
          <Link to="/programs" className="btn-secondary" data-testid="final-cta-programs">
            Explore Programs
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default ConversionCTA;
